import { render, staticRenderFns } from "./registrationLink.vue?vue&type=template&id=1f023e1c&"
import script from "./registrationLink.vue?vue&type=script&lang=js&"
export * from "./registrationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registrationLink.vue"
export default component.exports